export default __webpack_public_path__ + "static/media/press_1.ba366892.jpeg";